





































import Vue from 'vue';

export default Vue.extend({
  data() {
    return {
    };
  },
  computed: {
    sidebarActive() {
      return this.$store.state.sidebarActive;
    },
    overlayActive() {
      return this.$store.state.overlayActive;
    },
  },
  methods: {
    controlSidebar() {
      this.$store.commit('updateSidebarActive', !this.sidebarActive);
      this.$store.commit('updateOverlayActive', !this.overlayActive);
    },
  },
});
